<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.weChatOrderRefundList.push"
    :is-show-search-input="true"
    search-placeholder="请输入学员姓名、手机号或订单号"
  >
    <v-column-time/>
    <v-column-time value="更新时间" field="update_time" sortable=""/>
    <v-column-time value="微信受理时间" field="create_time_int" sortable=""/>
    <v-column-time value="退款成功时间" field="success_time_int" sortable=""/>
    <el-table-column label="退款订单 ID" align="center" prop="id"/>
    <el-table-column label="商户订单号" align="center" prop="out_trade_no"/>
    <el-table-column label="微信支付订单号" align="center" prop="transaction_id"/>
    <el-table-column label="商户退款单号" align="center" prop="out_refund_no"/>
    <v-column-student label="订单所属学员" link-page-id="student_id"/>
    <el-table-column label="订单总金额" align="center">
      <template v-slot="{ row }">
        {{ row.total | toYuan }}
      </template>
    </el-table-column>

    <el-table-column label="实际支付金额" align="center">
      <template v-slot="{ row }">
        {{ row.payer_total | toYuan }} 元
      </template>
    </el-table-column>

    <el-table-column label="退款总金额" align="center">
      <template v-slot="{ row }">
        {{ row.refund | toYuan }} 元
      </template>
    </el-table-column>

    <el-table-column label="退款到账金额" align="center">
      <template v-slot="{ row }">
        <span v-if="row.success_time_int">{{ row.payer_refund | toYuan }} 元</span>
        <span v-else>-</span>
      </template>
    </el-table-column>

    <el-table-column label="退款状态" align="center">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_reject" type="danger">申请失败</el-tag>
        <template v-else>
          <el-tag
            v-for="refundState in findRefundState(row.status)"
            :key="refundState.value"
            :type="refundState.tagType"
          >
            {{ refundState.name }}
          </el-tag>
        </template>
      </template>
    </el-table-column>

    <el-table-column label="退款入账账户" align="center" prop="user_received_account"/>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`we-chat-order-refund-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>更新时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>微信受理时间</span>
              <span>{{ v.create_time_int | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>退款成功时间</span>
              <span>{{ v.success_time_int | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>退款订单 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>商户订单号</span>
              <span>{{ v.out_trade_no }}</span>
            </div>
            <div class="list-item-detail">
              <span>微信支付订单号</span>
              <span>{{ v.transaction_id }}</span>
            </div>
            <div class="list-item-detail">
              <span>商户退款单号</span>
              <span>{{ v.out_refund_no }}</span>
            </div>
            <div class="list-item-detail">
              <span>订单所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>订单总金额</span>
              <span>{{ v.total | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>实际支付金额</span>
              <span>{{ v.payer_total | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>退款总金额</span>
              <span>{{ v.refund | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>退款到账金额</span>
              <span v-if="v.success_time_int">{{ v.payer_refund | toYuan }} 元</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>退款状态</span>
              <div class="list-item-info">
                <el-tag v-if="v.is_reject" type="danger">申请失败</el-tag>
                <template v-else>
                  <el-tag
                    v-for="refundState in findRefundState(v.status)"
                    :key="`refund-state-${v.id}-${refundState.value}`"
                    :type="refundState.tagType"
                  >
                    {{ refundState.name }}
                  </el-tag>
                </template>
              </div>
            </div>
            <div class="list-item-detail">
              <span>退款入账账户</span>
              <span>{{ v.user_received_account }}</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getRefundList } from '@/api/we-chat-order';
import { findRefundState } from "@/enums/refundStates";

export default {
  name: RouteConfig.weChatOrderRefundList.name,
  data: () => ({
    RouteConfig,
    findRefundState,
    isLoading: false,
    isDeleting: true,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 8,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getRefundList(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
